import axios from 'axios';
import {push} from 'connected-react-router/immutable';

import config from 'config';
import {timeoutError, offlineError} from '../services/errors';
import {authExpiredError, logout, noActiveCampaignError, showPrivacy} from '../actions/login';
import {LOGIN} from './routes';

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  timeout: config.requestTimeout,
};

// A simple fetch without default error interceptions
export function fetch(url, options = {}) {
  return axios(Object.assign({url}, defaultOptions, options));
}

// Use this when you need automatic network failures handling
export function buildFetch(dispatch) {
  return function fetch(url, options = {}) {
    return axios(Object.assign({url}, defaultOptions, options)).catch(error => {
      // Intercept network errors and propagate a null error to the promise chain
      const {response, message, code} = error;
      if (!response) {
        if (code === 'ECONNABORTED') {
          dispatch(timeoutError(message));

          return Promise.reject(null);
        } else if ((navigator && !navigator.onLine) || message === 'Network Error') {
          dispatch(offlineError(message));

          return Promise.reject(null);
        }
      } else if (response.status === 401 || response.status === 403) {
        dispatch(authExpiredError());
        dispatch(push(LOGIN));

        return Promise.reject(null);
      } else if (response.status === 422 && response.data.code === 'NO_ACTIVE_CAMPAIGN') {
        dispatch(logout());
        dispatch(noActiveCampaignError());
      } else if (response.data && response.data.key === 'NO_PRIVACY_CONSENT') {
        dispatch(showPrivacy());
      }

      // Otherwise propagate the ajax error to the chain
      return Promise.reject(error);
    });
  };
}
